import styled from 'styled-components';

const StyledCarouselHome = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  .paragraph--col-small{
    text-align: right;
  }
  .paragraph--col-wrap{
    margin-bottom: 80px;
  }
  .swiper-slide{
    width: calc(33.33% - 64px);
    margin-left: 8.33%;
    border-right: 2px solid #000;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .swiper-slide:nth-child(1){
    margin-left: 64px;
  }
  .text--slide{
    width: 75%;
    margin-bottom: 64px;
    margin-top: 40px;
    flex: 1 1 350px;
  }
  .text--slide p.paragraph--slide{
    padding: 24px 0;
  }
  .img--slide{
    position: relative;
    width: 100%;
    margin-bottom: 24px;
  }
  .img--slide img{
    position: relative;
    display: block;
    width: 100%;
    right: -25%;
  }
  @media screen and (max-width: 1439px){
    
  }
  @media screen and (max-width: 1023px){
    margin-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    .paragraph--col-wrap{
      margin-bottom: 64px;
    }
    .swiper-slide{
      width: calc(41.66% - 40px);
      margin-left: 8.33%;
      border-right: 1px solid #000;
      overflow: hidden;
    }
    .swiper-slide:nth-child(1){
      margin-left: 40px;
    }
    .text--slide{
      margin-top: 24px;
      margin-bottom: 40px;
    }
  }
  @media screen and (max-width: 767px){
    margin-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    .paragraph--col-wrap{
      margin-bottom: 40px;
    }
    .swiper-slide{
      width: calc(75% - 24px);
      margin-left: 8.33%;
      border-right: 1px solid #000;
      overflow: hidden;
    }
    .swiper-slide:nth-child(1){
      margin-left: 24px;
    }
    .text--slide{
      flex: 1 1 250px;
    }
  }
  .swiper-button-next {
    background-image: url(/arrow-next-carousel.svg);
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
    width: 64px;
    height: 64px;
    right: 64px;
    background-color: #000;
    border-radius: 50%;
    transition: background-color .25s;
  }
  .swiper-button-disabled{
    display: none;
  }
  .swiper-button-next::after {
    display: none;
  }
  .swiper-button-prev {
    background-image: url(/arrow-prev-carousel.svg);
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
    width: 64px;
    height: 64px;
    left: 64px;
    background-color: #000;
    border-radius: 50%;
    transition: background-color .25s;
  }
  
  .swiper-button-prev::after{
    display: none;
  }
  .swiper-button-prev:hover, .swiper-button-next:hover{
    background-color: ${props => props.theme.colors.green_secondary};
  }
  @media screen and (max-width: 1439px){
    .swiper-button-next {
      right: 40px
    }
    .swiper-button-prev {
      left: 40px
    }

  }
  @media screen and (max-width: 767px){
    .swiper-button-next,
    .swiper-button-prev{
      width: 44px;
      height: 44px;
      padding: 6px;
      background-color: transparent;
    }
    .swiper-button-next:hover,
    .swiper-button-prev:hover{
      background-color: transparent;
    }
    .swiper-button-next{
      right: 24px
    }
    .swiper-button-prev{
      left: 24px
    }
    .swiper-button-next::after,
    .swiper-button-prev::after {
      content: '';
      display: block;
      border-radius: 50%;
      background-color: #000;
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: center;
    }
    .swiper-button-next::after{
      background-image: url(/arrow-next-carousel.svg);
    }
    .swiper-button-prev::after{
      background-image: url(/arrow-prev-carousel.svg);
    }
  }
`;

export {
  StyledCarouselHome,
};

